<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'mission',

    metaInfo: { title: 'Missions d\'intérêt général' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'missions',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'mission',
      },
    },
  }
</script>
